// NOTE: jquery is loading from Kentico's `@Html.Kentico().PageBuilderScripts()`
// Jquery is configured in webpack as an 'external' so will not be included in any bundles.
// Referenced here for IDE magic and autocomplete suggestions purposes only.
window.jQuery = window.$ = require('jquery')

import Cookies from 'js-cookie'
window.Cookies = Cookies

require('../scripts/dbs/dbs.events')
require('../scripts/dbs/dbs.events.shepherd')
require('../scripts/dbs/dbs.request')
require('../scripts/dbs/dbs.response')
require('../scripts/dbs/dbs.utilities')
require('../scripts/dbs/dbs.layout')

// Semantic UI
//
// This is out base UI library that we partially utilise to build our base styles and widgets.
// Import order is important, so refer to Semantic UI's git src for reference.
// See: https://github.com/Semantic-Org/Semantic-UI/blob/master/src/semantic.less

// Site reset and default styles
import(/* webpackMode: "eager" */ '../plugins/semantic/reset.css')
import(/* webpackMode: "eager" */ './global.scss')

// Flutter Event Handlers
import(/* webpackMode: "eager" */'../flutter/flutter.events.handlers');
import(/* webpackMode: "eager" */'../flutter/flutter.global.scss');

// Base elements
// Typically required by widgets, so should be imported first
import(/* webpackMode: "eager" */ '../plugins/semantic/icon.css')
import(/* webpackMode: "eager" */ '../plugins/semantic/image.css')
import(/* webpackMode: "eager" */ '../plugins/semantic/input.scss')
import(/* webpackMode: "eager" */ '../plugins/semantic/label.css')
import(/* webpackMode: "eager" */ '../plugins/semantic/loader.css')
import(/* webpackMode: "eager" */ '../plugins/semantic/message.scss')
import(/* webpackMode: "eager" */ '../plugins/semantic/dimmer')
import(/* webpackMode: "eager" */ '../plugins/semantic/dimmer.scss')
import(/* webpackMode: "eager" */ '../plugins/semantic/dropdown.scss')
import(/* webpackMode: "eager" */ '../plugins/semantic/modal.scss')
import(/* webpackMode: "eager" */ '../plugins/semantic/popup.css')
import(/* webpackMode: "eager" */ '../plugins/semantic/tab.css')
import(/* webpackMode: "eager" */ '../plugins/semantic/transition')
import(/* webpackMode: "eager" */ '../plugins/semantic/transition.css')
import(/* webpackMode: "eager" */ '../plugins/semantic/form.scss')

// Global widgets
//
import(/* webpackMode: "eager" */ '../widgets/header/header')
import(/* webpackMode: "eager" */ '../widgets/gdpr/gdpr') // "eager" to ensure GDPR loads before any other modal widgets
import(/* webpackMode: "eager" */'../widgets/footer/footer')
import(/* webpackMode: "eager" */ '../widgets/footer/footer.scss')

// Critical widgets CSS (CW20-193 Fix layout shift)
//
// Critical CSS for widgets is used to controls excessive layout shift, caused
// by the widget mark-up in the DOM before the widget stylesheet has lazy loaded.
// For example, critical CSS can hide a modals mark-up during page load, as opposed to
// rendering in DOM and hidden once the widget stylesheet has loaded later.
// These styles are bundled with global.css, which is blocking page render, and loaded immediately.
import(/* webpackMode: "eager" */ '../widgets/mobile-menu/mobile-menu-critical.scss')
import(/* webpackMode: "eager" */ '../widgets/dhp-popup/dhp-popup-critical.scss')
import(/* webpackMode: "eager" */ '../widgets/gdpr/gdpr-critical.scss')
import(/* webpackMode: "eager" */ '../widgets/partner-promo-image/partner-promo-image-critical.scss')
// Common widgets
//
import(/* webpackMode: "eager" */ '../widgets/breadcrumbs/breadcrumbs.scss')


// Filter out key press to only allow number characters to be entered
$('input.number-only').keypress(function (event) {
  let key = event.keyCode || event.which
  key = String.fromCharCode(key)

  const regex = '^[0-9]*$'
  if (!key.match(regex)) {
    event.preventDefault()
  }
})

// Appends the query from the page URL to any <a href> with the class `.append-querystring`
// E.g. from `<a class="append-querystring" href="/example">` to `<a class="append-querystring" href="/example?foo=bar">`
$('.append-querystring').each(function (i, el) {
  const qs = window.location.href.split('?')[1]
  const currentUrl = $(el).attr('href')
  if (qs && qs.length > 1) {
    $(el).attr('href', currentUrl + '?' + qs)
  }
})

  /* Apply a CSS class hook to the body tag based on the screen width */
  ; (function () {
    const $body = $('body')
    const isMobileLargeMax = window.matchMedia('(max-width: 767px)')
    const updateBodyCssClass = function (e) {
      if (e.matches) {
        $body.addClass('is-mobile-view').removeClass('is-desktop-view')
      } else {
        $body.addClass('is-desktop-view').removeClass('is-mobile-view')
      }
    }

    updateBodyCssClass(isMobileLargeMax) // runs on init
    isMobileLargeMax.addEventListener('change', updateBodyCssClass)
  })()
// Hack to force mobile to add guest
window.dbs.globalEvents.subscribe("guestselector:updated", function (data) {
  if($('html').hasClass('gday-theme') && $('.pt-cabin-detail--main').length >=1) {
    if ($(window).width() < 768) {
      console.log('refreshing');
      window.location = window.location
    }
  }
})


// Create our Google Tag Manager data layer.
// IMPORTANT: Add before Tag Manager script is loaded.
// See: https://developers.google.com/tag-platform/tag-manager/web/datalayer#installation
window.dataLayer = window.dataLayer || []

